import service from '@api/config'

// 筛选条件查询找活干列表
export const findJobList = (data) => {
  return service.request({
    url: `/findJob/list`,
    method: 'post',
    data: data
  })
}

// 获取当前身份默认找活信息
export const findJobInit = (data) => {
  return service.request({
    url: `/recruit/worker/info`,
    method: 'post',
    data: data
  })
}
// 获取别人的招工信息
export const workerDetail = (data) => {
  return service.request({
    url: `/recruit/worker/detail`,
    method: 'post',
    data: data
  })
}

// 发布找活广告
export const findJobPublish = (data) => {
  return service.request({
    url: `/recruit/worker/publish`,
    method: 'post',
    data: data
  })
}

// 删除已发布的找活广告信息
export const findJobDelete = (data) => {
  return service.request({
    url: `/findJob/delete`,
    method: 'post',
    data: data
  })
}

// 我参与的 简易流程项目 信息查询
export const getSimpleProjectInfo = (data) => {
  return service.request({
    url: `/project/getSimpleProjectInfo`,
    method: 'post',
    data: data
  })
}

// 简易流程项目 信息查询，字段简化
export const getInfo = (data) => {
  return service.request({
    url: `/project/getInfo`,
    method: 'post',
    data: data
  })
}

// 项目详情  标准流程
export const getNormalProjectInfo = (data) => {
  return service.request({
    url: `/project/getNormalProjectInfo`,
    method: 'post',
    data: data
  })
}

// 判断是否已报名
export const getProjectTenderFlag = (data) => {
  return service.request({
    url: `/project/getProjectTenderFlag`,
    method: 'post',
    data: data
  })
}

// 查看已发布的信息
export const findJobFindJob = (data) => {
  return service.request({
    url: `/findJob/history`,
    method: 'post',
    data: data
  })
}

// 获取找活列表
export const findWorkList = (data) => {
  return service.request({
    url: `/find/work/list`,
    method: 'post',
    data: data
  })
}

// 刷新找活广告
export const refresh = (data) => {
  return service.request({
    url: `/recruit/worker/refresh`,
    method: 'post',
    data: data
  })
}

// 投诉
export const userFeedback = (data) => {
  return service.request({
    url: `/user/feedback`,
    method: 'post',
    data: data
  })
}

// 获取招工方基本信息
export const getEmployerInfo = (data) => {
  return service.request({
    url: `/project/v4.0/getEmployerInfo`,
    method: 'post',
    data: data
  })
}

// 发布找活广告后的的推荐项目列表
export const afterPubList = (data) => {
  return service.request({
    url: `/find/work/v4.0/afterPub/list`,
    method: 'post',
    data: data
  })
}

// 添加朋友
export const addFriend = (data) => {
  return service.request({
    url: `/project/statistic/addFriend`,
    method: 'post',
    data: data
  })
}

// 获取用户信息
export const getUserInfo = (data) => {
  return service.request({
    url: `/user/getInfo`,
    method: 'post',
    data: data
  })
}

// 获取班组信息
export const getCurrentEnterprise = (data) => {
  return service.request({
    url: `/company/getCurrentEnterprise`,
    method: 'post',
    data: data
  })
}

// 根据项目id推荐项目信息列表，带分页
export const recommendProjectList = (data) => {
  return service.request({
    url: `/project/v4.0/recommend/list`,
    method: 'post',
    data: data
  })
}
